import { z } from 'zod'

type TreatmentAttributes = Record<string, string | number | boolean | undefined>

const treatmentsResponseSchema = z.object({
  treatments: z.record(z.string()),
})

export const fetchTreatments = async (
  names: readonly string[],
  attributes?: TreatmentAttributes
): Promise<Record<string, string>> => {
  const response = await fetch('/api/treatments', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ names, attributes }),
  })
  if (!response.ok) {
    return {}
  }
  const parsed = treatmentsResponseSchema.safeParse(await response.json())
  return parsed.success ? parsed.data.treatments : {}
}

export const fetchTreatment = async (
  name: string,
  attributes?: TreatmentAttributes
): Promise<string | undefined> => {
  const treatments = await fetchTreatments([name], attributes)
  return treatments[name]
}
